import { useOutletContext } from "react-router-dom";
import { useNavigate } from "react-router-dom"; 
import { deleteRealEstate } from "../../services/Real_estate"
import StyleForAllPartsMy from "./StyleForAllParts/StyleForAllPartsMy";
import StyleForAllPartsNotMy from "./StyleForAllParts/StyleForAllPartsNotMy";
import "./userPage.css";


export default function SearchedData({
  my,
  searchedData,
  setEstateOn,
  setAlldeleted,
  setData,
  setSearchedData,
}) {
  const { brokerinfo } = useOutletContext();
  const navigate = useNavigate();
  const id = brokerinfo.broker_id || brokerinfo.manager_id;
  const handleDelete = async (el, estateId) => {
    try {

      setData((prev) =>
        prev.filter((item) => {
          const id =
            item?.apartment_id ??
            item?.house_id ??
            item?.land_id ??
            item?.commercial_id;

          return Number(id) !== Number(estateId);
        })
      );

      setSearchedData((prev) =>
        prev.filter((item) => {
          const id =
            item?.apartment_id ??
            item?.house_id ??
            item?.land_id ??
            item?.commercial_id;

          return Number(id) !== Number(estateId);
        })
      );

      setAlldeleted((prev) => [...prev, el]);
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  console.log("hvhjgcjhgvh", searchedData);
  return (
	  <div>
	  <p style={{textAlign:"center"}}>ԳՏՆՎԱԾ ԳՈՒՅՔԵՐԻ ՔԱՆԱԿ՝ {searchedData.length}</p>
      <div className="allelements">{searchedData.map((el) => {
        const estateId =
          el?.apartment_id ?? el?.house_id ?? el?.land_id ?? el?.commercial_id;
        if (my === true) {
          if (
            el.broker_id === brokerinfo.broker_id ||
            el.manager_id === brokerinfo.manager_id
          ) {
            return(<StyleForAllPartsMy
              el={el}
              estateId={estateId}
              setEstateOn={setEstateOn}
              navigate={navigate}
              id={id}
              brokerinfo={brokerinfo}
              deleteRealEstate={deleteRealEstate}
              handleDelete={handleDelete}
            />)
          } else {
            return null;
          }
        } else {
          return(<StyleForAllPartsNotMy
            el={el}
            estateId={estateId}
            setEstateOn={setEstateOn}
            navigate={navigate}
            id={id}
            brokerinfo={brokerinfo}
            deleteRealEstate={deleteRealEstate}
            handleDelete={handleDelete}
          />)
        }
      })}</div>
    </div>
  );
}
